import React, {PureComponent} from "react";
import sAction from "sAction";
import Autocomplete from "../formElements/Autocomplete";

export default class RecipientInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      resultOpen: false,
      searchText: "",
    }
    this.input = React.createRef();
    this.autocomplete = React.createRef();
  }


  textProcess = () => {
     if(!this.input?.current){
       return
     }
    let text = this.input?.current?.value;
    sAction.dataSet(this.props.way + "/" + this.props.id, text);
    text = text.replace(/\s+/g, ''); //odstraneni mezer
    text = text.replace(";", ','); // nahrada ; za ,
    return text.split(",");
  }

  keyUp = (e) => {
    let text = this.input?.current?.value;
    const keyCode = e.keyCode;
    switch(keyCode){
      case 38:
      case 40:
        if(this.autocomplete?.current){
          this.autocomplete.current.keyUpHandler(keyCode);
        }
      break;
      case 13:
        if(this.autocomplete?.current){
          this.autocomplete.current.keyUpHandler(keyCode);
        }
      break;
      case 27:
        this.setState({resultOpen: false})
      break;
      default:
          const addressees = this.textProcess();
          const searchText = addressees[addressees.length - 1];
          if(searchText !== ""){
            this.setState({resultOpen:true,searchText: searchText})
          } else {
            this.setState({resultOpen:false});
          }

          //sAction.dataSet(this.props.way + "/" + this.props.id, text);
      break;
    }
  }

  storeEmail = (item) => {
    if(item){
      let addressees = this.textProcess();
      addressees[addressees.length - 1] = item.name;
      let text = addressees.join(", ");
      this.input.current.value = text;
      sAction.dataSet(this.props.way + "/" + this.props.id, text);
      this.setState({resultOpen: false})
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if(this.props.value !== nextProps.value && this.input?.current){
      this.input.current.value = nextProps.value;
    }
  }

  render(){
    return (
      <>
        <div
          tabIndex={0}
          className={"recipientInput"}
        >
          <input
            type="text"
            id={this.props.id}
            name={this.props.id}
            defaultValue={this.props.value}
            disabled={this.props.disabled || false}
            onKeyUp={(e) => this.keyUp(e)}
            ref={this.input}
            className={"w100"}
            autoComplete={"off"} /*vypnuti prohlizecoveho autocompletu*/
          />
          {
            this.state.resultOpen ? <Autocomplete
              resultOpen={this.state.resultOpen}
              searchText={this.state.searchText}
              searchMethod={"email"}
              autocompleteReturnItem={this.storeEmail}
              ref={this.autocomplete}
            /> : null}
        </div>
      </>

    )
  }
}

